import React, { memo, useState, useEffect, useContext } from "react";
import { Grid } from "@mui/material";
import { ToggleTitleWrapper, ToggleSwitch } from "../../../styled/ToggleTile.styled";
import { HorizontalSeparator } from "../../../styled/SidePanel.style";
import SidePanelCard from "../../StyledSidePanelCard";
import TopMSPanel from "./TopMSPanel";
import OperatorMSPanel from "./OperatorMSPanel";
import { WebMapContext } from "../../../../pages/sections/web-map/WebMapGoogleMap";
import { LoadMapContext } from "../../../../pages/sections/web-map/LoadWebMap";

const MarketSharePanel = ({
  isMarketShareChecked,
  isMarketShareVisible,
  marketShareSidePanelOnClick = () => { },
  onClickMarketShareVisibility = () => { },
  toggleTopMarketShare,
  opMSChartView,
  opMSPerm,
  topMSAggrPerm,
  opMSAggrPerm,
  topMSPerm
}) => {
  const { appliedFilters, mapPlacement } = useContext(WebMapContext);
  const { mapView, setCollapseSideBar, setShowMsModal, setIsIbsTableOpen, isIbsTableOpen, setIsOpMsTableOpen } = useContext(LoadMapContext);
  const [isTopMarketShareChecked, setIsTopMarketShareChecked] = useState(true);
  const [openOptrMSModal, setOpenOptrMSModal] = useState(false);

  const { countryCode, year, quarter } = appliedFilters;

  useEffect(() => {
    setIsTopMarketShareChecked(true);
    setOpenOptrMSModal(false);
  }, [countryCode]);

  useEffect(() => {
    setOpenOptrMSModal(false);
  }, [countryCode, year, quarter]);

  useEffect(() => {
    if (openOptrMSModal) setIsOpMsTableOpen(true);
  }, [openOptrMSModal]);

  useEffect(() => {
    if (openOptrMSModal && isIbsTableOpen) setOpenOptrMSModal(false);
  }, [isIbsTableOpen]);

  const handleTopMarketShareChange = (checked) => {
    toggleTopMarketShare();
    setIsTopMarketShareChecked(checked);
    if (checked) setOpenOptrMSModal(false);
  };

  const handleSideBar = () => {
    onClickIcon();
    if (mapPlacement === "right") {
      setCollapseSideBar({rightSideBar: false, leftSideBar: true });
      setShowMsModal({rightModal: true, leftModal: false })
    } else {
      setCollapseSideBar({rightSideBar: true, leftSideBar: false });
      setShowMsModal({rightModal: false, leftModal: true });
    }
  };
 
  const onClickIcon = () => {
    setIsIbsTableOpen(false);
    setOpenOptrMSModal(!openOptrMSModal);
  };

  return (
    <>
      <SidePanelCard
        title="Market Share"
        icon={
          isMarketShareChecked
            ? "/assets/marketShareIconActive.png"
            : "/assets/marketShareIcon.png"
        }
        nonShow={true}
        clicked={isMarketShareChecked}
        onClick={marketShareSidePanelOnClick}
        isVisibleAsGreen={true}
        visibilityClicked={isMarketShareVisible}
        onClickVisibility={onClickMarketShareVisibility}
        iconInfo={{
          icon: isMarketShareChecked ? "/assets/searchDataIconActive.png" : "/assets/searchDataIcon.png",
          showIcon: opMSChartView.is_enable === true ? !isTopMarketShareChecked : false,
          onClickIcon: () => mapView === null ? onClickIcon() : handleSideBar()
        }
        }
      />
      <Grid
        container
        item
        style={{
          justifyContent: "space-between",
          textAlign: "left",
          font: "normal normal normal 12px/16px Open Sans",
          letterSpacing: "0px",
          color: "black",
          opacity: "1",
          ...(isMarketShareChecked && { padding: "10px" })
        }}
      >
        {isMarketShareChecked && (
          <>
          {topMSPerm?.is_enable === true && (
            <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
              <ToggleTitleWrapper main>Top Market Share</ToggleTitleWrapper>
              <ToggleSwitch
                checked={isTopMarketShareChecked}
                onChange={(e) => handleTopMarketShareChange(e.target.checked)}
              />
          </div>
          )}
            {!isTopMarketShareChecked && (
              <>
              {opMSPerm?.is_enable === true && (
                <>
                {topMSPerm?.is_enable === true && (<HorizontalSeparator />)}
                  <ToggleTitleWrapper main>Operator Market Share</ToggleTitleWrapper>
                  <ToggleSwitch
                    checked={!isTopMarketShareChecked}
                    onChange={(e) => handleTopMarketShareChange(!e.target.checked)}
                  />
                </>
              )}
              </>)}
          </>
        )}
        {topMSPerm?.is_enable === true && (
          <TopMSPanel
            isVisible={isMarketShareChecked} // panel visible
            eyeIcon={isMarketShareVisible}
            topMSChecked={isTopMarketShareChecked}
            topMSAggrPerm = {topMSAggrPerm}
          />
        )}
        {opMSPerm?.is_enable === true && (
          <OperatorMSPanel
            isVisible={isMarketShareChecked}
            eyeIcon={isMarketShareVisible}
            topMSChecked={isTopMarketShareChecked}
            isModalOpen={openOptrMSModal}
            opMSAggrPerm = {opMSAggrPerm}
            handleModalClose={setOpenOptrMSModal}
          />
        )}
        {isMarketShareChecked && isTopMarketShareChecked && (
          <>
            {topMSPerm?.is_enable === true && opMSPerm?.is_enable === true && (<HorizontalSeparator />)}
            {opMSPerm?.is_enable === true && (
              <>
                <ToggleTitleWrapper main>Operator Market Share</ToggleTitleWrapper>
                <ToggleSwitch
                  checked={!isTopMarketShareChecked}
                  onChange={(e) => handleTopMarketShareChange(!e.target.checked)}
                />
              </>
            )}
          </>
        )}
      </Grid>
    </>
  );
}

export default memo(MarketSharePanel);
